import React from "react";

import { MessagesDataContext } from "./MessagesDataProvider";

const useMessagesDataContext = () => {
  const context = React.useContext(MessagesDataContext);

  if (!context) {
    throw new Error(
      "useMessagesDataContext must be used within a MessagesDataProvider",
    );
  }

  return context;
};

const useMessagesData = () => useMessagesDataContext().messages;

export { useMessagesDataContext, useMessagesData };
